import { useSelector } from 'react-redux';

import type { Type } from '@/domains/productDiscovery/CommercialAnimation/interfaces/bannerCampaign';

import {
  merchandizingBannersInitialState,
  type MerchandizingBannerState,
} from '../MerchandizingBanners.model';
import { selectMerchandizingBanners } from '../selectors/selectMerchandizingCampaigns';

export const useMerchandizingBanners = (type: Type): MerchandizingBannerState =>
  useSelector(selectMerchandizingBanners(type)) ||
  merchandizingBannersInitialState[type];
